<app-loader [isBusy]="isBusy">
    <ng-template>
        <form [formGroup]="form" (ngSubmit)="save()">
            <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <button class="close" type="button" aria-label="Close" (click)="activeModal.close(null)">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row card-border-top">
                    <div class="card-body pt-0">
                        <div class="row mt-2">
                            <div class="col">
                                <form-dropdown
                                    labelText="{{ 'Vehicle Type' | translate }}"
                                    codeListName="VehicleType"
                                    formControlName="vehicleTypeId"></form-dropdown>
                            </div>
                            <div class="col">
                                <form-dropdown
                                    labelText="{{ 'Brand' | translate }}"
                                    codeListName="VehicleBrand"
                                    formControlName="vehicleBrandId"></form-dropdown>
                            </div>
                            <div class="col">
                                <form-textbox
                                    labelText="{{ 'Vehicle Number (VIN)' | translate }}"
                                    formControlName="vehicleNumber"
                                    contextual="{{ 'VIN or Licence Plate is mandatory.' | translate }}"></form-textbox>
                            </div>
                            <div class="col">
                                <form-textbox
                                    labelText="{{ 'Licence Plate' | translate }}"
                                    formControlName="licencePlate"
                                    contextual="{{ 'VIN or Licence Plate is mandatory.' | translate }}"></form-textbox>
                            </div>
                            <div class="col">
                                <form-number
                                    labelText="{{ 'Produced Year' | translate }}"
                                    formControlName="producedYear"
                                    [year]="true"></form-number>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col">
                                <form-textbox
                                    labelText="{{ 'Driver Name' | translate }}"
                                    formControlName="driverName"></form-textbox>
                            </div>
                            <div class="col">
                                <form-textbox
                                    labelText="{{ 'Second Driver' | translate }}"
                                    formControlName="secondDriver"></form-textbox>
                            </div>
                            <div class="col">
                                <form-textbox
                                    labelText="{{ 'Owner' | translate }}"
                                    formControlName="owner"></form-textbox>
                            </div>
                            <div class="col">
                                <form-textbox
                                    labelText="{{ 'Receiver' | translate }}"
                                    formControlName="receiver"></form-textbox>
                            </div>
                            <div class="col">
                                <form-textbox
                                    labelText="{{ 'Consignee' | translate }}"
                                    formControlName="consignee"></form-textbox>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col">
                                <form-dropdown
                                    labelText="{{ 'Origin' | translate }}"
                                    codeListName="Flag"
                                    formControlName="originId"></form-dropdown>
                            </div>
                            <div class="col">
                                <form-dropdown
                                    labelText="{{ 'Port of Loading' | translate }}"
                                    codeListName="Port"
                                    formControlName="portOfLoadingId"></form-dropdown>
                            </div>
                            <div class="col">
                                <form-dropdown
                                    labelText="{{ 'Destination Country' | translate }}"
                                    codeListName="Flag"
                                    formControlName="destinationCountryId"></form-dropdown>
                            </div>
                            <div class="col">
                                <form-dropdown
                                    labelText="{{ 'Port of Discharge' | translate }}"
                                    codeListName="Port"
                                    formControlName="portOfDischargeId"></form-dropdown>
                            </div>
                            <div class="col">
                                <form-textbox
                                    labelText="{{ 'TIR/CMR' | translate }}"
                                    formControlName="tir"></form-textbox>
                            </div>
                        </div>
                        <hr />
                        <div class="row mt-2">
                            <div class="col">
                                <form-number
                                    labelText="{{ 'Length' | translate }}"
                                    formControlName="length"
                                    [decimal]="true"></form-number>
                            </div>
                            <div class="col">
                                <form-number
                                    labelText="{{ 'Tare Weight (kg)' | translate }}"
                                    formControlName="taraWeight"
                                    [decimal]="true"></form-number>
                            </div>
                            <div class="col">
                                <form-number
                                    labelText="{{ 'Composition Length' | translate }}"
                                    formControlName="compositionLength"
                                    [decimal]="true"></form-number>
                            </div>
                            <div class="col">
                                <form-checkbox
                                    labelText="{{ 'Has Cargo' | translate }}"
                                    formControlName="hasCargo"></form-checkbox>
                            </div>
                            <div class="col">
                                <form-checkbox
                                    labelText="{{ 'New Vehicle' | translate }}"
                                    formControlName="newVehicle"></form-checkbox>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col">
                                <form-number
                                    labelText="{{ 'Cargo Net Weight (kg)' | translate }}"
                                    formControlName="cargoNetWeight"
                                    [emptyIfZero]="true"
                                    [decimal]="true"></form-number>
                            </div>
                            <div class="col">
                                <form-number
                                    labelText="{{ 'Cargo Gross Weight (kg)' | translate }}"
                                    formControlName="cargoGrossWeight"
                                    [emptyIfZero]="true"
                                    [decimal]="true"></form-number>
                            </div>
                            <div class="col">
                                <form-textarea
                                    labelText="{{ 'Particulars' | translate }}"
                                    formControlName="particulars"></form-textarea>
                            </div>
                            <div class="col">
                                <form-checkbox
                                    labelText="{{ 'Dangerous Cargo' | translate }}"
                                    formControlName="hasDangerousCargo"
                                    (click)="toggleShowIMDG()"></form-checkbox>
                            </div>
                        </div>
                        @if (showIMDG) {
                            <div class="row mt-2">
                                <div class="col">
                                    <form-dropdown
                                        labelText="{{ 'IMDG' | translate }}"
                                        codeListName="ImdgClass"
                                        formControlName="imdg"></form-dropdown>
                                </div>
                                <div class="col">
                                    <form-dropdown
                                        labelText="{{ 'UN Number' | translate }}"
                                        codeListName="UnNumber"
                                        formControlName="unNumber"
                                        (valueChange)="onUnNumberChange($event)"></form-dropdown>
                                </div>
                                <div class="col">
                                    <form-dropdown
                                        labelText="{{ 'Imdg Pck. Group' | translate }}"
                                        codeListName="ImdgPackingGroup"
                                        formControlName="imdgPackingGroup"
                                        (valueChange)="onImdgPackingGroupChange($event)"></form-dropdown>
                                </div>
                                <div class="col">
                                    <form-dropdown
                                        labelText="{{ 'ADR' | translate }}"
                                        formControlName="adrId"
                                        [observableInput]="adrs$"
                                        [automaticPopulateWithFirstValue]="true"></form-dropdown>
                                </div>
                                <div class="col">
                                    <form-textarea
                                        labelText="{{ 'Tehnical Name' | translate }}"
                                        formControlName="technicalName"></form-textarea>
                                </div>
                                <div class="col">
                                    <form-textbox
                                        labelText="{{ 'DG Contact' | translate }}"
                                        formControlName="dgContact"></form-textbox>
                                </div>
                            </div>
                        }
                        <div class="row mt-2">
                            <div class="col">
                                <form-textbox
                                    labelText="{{ 'Remark' | translate }}"
                                    formControlName="remark"></form-textbox>
                            </div>
                            @if (showLinkedUnitField()) {
                                <div class="col">
                                    <form-dropdown
                                        labelText="{{ 'Linked Unit' | translate }}"
                                        formControlName="linkedUnitVehicleId"
                                        contextual="{{
                                            'Select the parent unit this vehicle is loaded onto or attached to'
                                                | translate
                                        }}"
                                        [observableInput]="linkedUnitOptions$"></form-dropdown>
                                </div>
                            }
                        </div>
                        <hr />
                        <div class="row mt-2">
                            <div class="col">
                                <form-textbox
                                    labelText="{{ 'Container Number 1' | translate }}"
                                    formControlName="containerNumberFirst"></form-textbox>
                            </div>
                            <div class="col">
                                <form-textbox
                                    labelText="{{ 'Container Number 2' | translate }}"
                                    formControlName="containerNumberSecond"></form-textbox>
                            </div>
                        </div>
                        <hr />
                        <div class="row mt-2">
                            <div class="col">
                                <button class="btn btn-sm btn-primary" type="button" (click)="addTrailer()">
                                    <fa-icon [icon]="['fas', 'plus']"></fa-icon>
                                </button>
                            </div>
                        </div>
                        <div formArrayName="trailers">
                            @for (trailer of form.get('trailers').controls; track trailer; let i = $index) {
                                <div [formGroupName]="i">
                                    <div class="row mt-2">
                                        <div class="col">
                                            <form-textbox
                                                labelText="{{ 'Trailer' | translate }}"
                                                formControlName="trailerLicencePlate"></form-textbox>
                                        </div>
                                        <div class="col">
                                            <form-number
                                                labelText="{{ 'Length' | translate }}"
                                                formControlName="trailerLength"
                                                [decimal]="true"></form-number>
                                        </div>
                                        <div class="col">
                                            <form-number
                                                labelText="{{ 'Tare Weight (kg)' | translate }}"
                                                formControlName="trailerTaraWeight"
                                                [decimal]="true"></form-number>
                                        </div>
                                        <div class="col">
                                            <form-checkbox
                                                labelText="{{ 'Has Cargo' | translate }}"
                                                formControlName="trailerHasCargo"></form-checkbox>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col">
                                            <form-number
                                                labelText="{{ 'Cargo Net Weight (kg)' | translate }}"
                                                formControlName="trailerCargoNetWeight"
                                                [decimal]="true"></form-number>
                                        </div>
                                        <div class="col">
                                            <form-number
                                                labelText="{{ 'Cargo Gross Weight (kg)' | translate }}"
                                                formControlName="trailerCargoGrossWeight"
                                                [decimal]="true"></form-number>
                                        </div>
                                        <div class="col">
                                            <form-textarea
                                                labelText="{{ 'Particulars' | translate }}"
                                                formControlName="trailerParticulars"></form-textarea>
                                        </div>
                                        <div class="col">
                                            <form-checkbox
                                                labelText="{{ 'Dangerous Cargo' | translate }}"
                                                formControlName="trailerHasDangerousCargo"></form-checkbox>
                                        </div>
                                        <div class="col-lg-1">
                                            <button
                                                class="btn btn-sm btn-danger"
                                                type="button"
                                                (click)="removeTrailer(i)">
                                                <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col">
                                            <form-textbox
                                                labelText="{{ 'Container Number 1' | translate }}"
                                                formControlName="trailerContainerNumberFirst"></form-textbox>
                                        </div>
                                        <div class="col">
                                            <form-textbox
                                                labelText="{{ 'Container Number 2' | translate }}"
                                                formControlName="trailerContainerNumberSecond"></form-textbox>
                                        </div>
                                    </div>
                                    @if (trailer.get('trailerHasDangerousCargo').value) {
                                        <div class="row mt-2">
                                            <div class="col">
                                                <form-dropdown
                                                    labelText="{{ 'IMDG' | translate }}"
                                                    codeListName="ImdgClass"
                                                    formControlName="trailerIMDG"></form-dropdown>
                                            </div>
                                            <div class="col">
                                                <form-dropdown
                                                    labelText="{{ 'UN Number' | translate }}"
                                                    codeListName="UnNumber"
                                                    formControlName="trailerUNNumber"></form-dropdown>
                                            </div>
                                            <div class="col">
                                                <form-dropdown
                                                    labelText="{{ 'Imdg Pck. Group' | translate }}"
                                                    codeListName="ImdgPackingGroup"
                                                    formControlName="trailerImdgPackaginGroup"></form-dropdown>
                                            </div>
                                            <div class="col">
                                                <form-textbox
                                                    labelText="{{ 'Tehnical Name' | translate }}"
                                                    formControlName="trailerTechnicalName"></form-textbox>
                                            </div>
                                            <div class="col">
                                                <form-textbox
                                                    labelText="{{ 'DG Contact' | translate }}"
                                                    formControlName="trailerDGContact"></form-textbox>
                                            </div>
                                        </div>
                                    }
                                    <hr />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-sm btn-primary mr-2" type="button" [disabled]="!form.valid" (click)="save()">
                    <fa-icon [icon]="['fas', 'check']"></fa-icon>
                    &nbsp;&nbsp;{{ 'Save' | translate }}
                </button>
                <button class="btn btn-sm btn-secondary" type="button" (click)="activeModal.close(null)">
                    <fa-icon [icon]="['fas', 'times']"></fa-icon>
                    &nbsp;&nbsp;{{ 'Cancel' | translate }}
                </button>
            </div>
        </form>
    </ng-template>
</app-loader>
